@if (columnDefinition.filterable) {
  <div class="dropdown" ngbDropdown [placement]="lastColumn ? 'bottom-right' : 'bottom-left bottom-right top-left top-right'">
    <i role="button" id="dropdownMenuLink" ngbDropdownToggle aria-haspopup="true" aria-expanded="false"
       class="material-icons" style="line-height: 16px; font-size: 18px; cursor:pointer;"
       [style.color]="columnDefinition.filterTerm?'black':'lightgray'"
       (click)="$event.stopPropagation()">filter_list</i>
    <div class="dropdown-menu"  ngbDropdownMenu aria-labelledby="dropdownMenuLink">
        <div style="display: flex; flex-direction:column; flex-wrap:nowrap; padding: 5px; overflow-y:auto; max-height: 250px;" (click)="$event.stopPropagation()">
          @for (option of options; track $index) {
            <text-filter-option [text]="option.text" [showSeparator]="option.showSeparator" [checked]="option.checked" (stateChanged)="option.raiseStateChanged($event)"></text-filter-option>
          }
        </div>
    </div>
  </div>
}
